import React from "react";
import useInView from "../../../hooks/useInView";
import "./TarjetaDeServicioData.css";

interface ServiceItem {
  title: string;
  desc: string;
}

interface TarjetaDeServicioDataProps {
  service: ServiceItem;
  delay?: number;
  animationClass?: string;
}

export default function TarjetaDeServicioData({ service, delay = 0, animationClass = "" }: TarjetaDeServicioDataProps) {
  const [ref, inView] = useInView({ threshold: 0.3 });

  return (
    <div
      ref={ref}
      className={`service-card animate-card${inView ? " visible" : ""} ${animationClass}`}
      style={{ transitionDelay: `${delay}s` } as React.CSSProperties}
    >
      <h3 className="service-data-title">{service.title}</h3>
      <p className="service-data-text">{service.desc}</p>
    </div>
  );
}